import PropTypes from "prop-types";
import { useState } from "react";
import {
  ChevronRight,
  ChevronLeft,
  IndianRupee,
  BedDouble,
  MapPin,
  Ruler,
} from "lucide-react";
import CustomButton from "../../shared/CustomButton";
import { Link, redirect } from "react-router-dom";
import { useNavigate } from "react-router-dom"; // Import useNavigate

const projectsPerPage = 3;
const Slider_card = ({ sliderData }) => {
  const hide = sliderData.hide;
  const heading = sliderData.tagline;
  const projects = sliderData.data;
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(projects.length / projectsPerPage);

  // Slice developers based on the current page and projectsPerPage
  const currentProjects = projects.slice(
    (currentPage - 1) * projectsPerPage,
    currentPage * projectsPerPage
  );

  const handleNext = () => {
    if (currentPage < Math.ceil(projects.length / projectsPerPage)) {
      setCurrentPage((prevPage) => prevPage + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };
  console.log("dadsad", currentProjects);
  // Redirect function
  const redirect = (url) => {
    navigate(url); // Use navigate to redirect to the desired URL
  };
  return (
    <div className="w-full flex justify-center  mt-10">
      <div className="w-full flex flex-col sm:w-full md:w-2/3 lg:w-1/2 xl:w-2/3 px-2 md:px-0">
        <div className=" flex flex-col items-center justify-center p-4 sm:p-6 lg:p-8">
          <h2 className=" text-lg md:text-4xl mb-12 text-center  ">
            {heading}
          </h2>

          {/* Responsive grid container for cards */}
          <div className="grid  sm:grid-cols-3 lg:grid-cols-3 gap-6 w-full">
            {currentProjects.map((news, index) => (
              <Link className="wow fadeInUp no-underline" to={news.link} key={news.id}>
                <div className="news-one__single">
                  <div className="news-one__img-box">
                    <div className="news-one__img">
                      <img
                        src={news.image}
                        alt={news.alt}
                        className="rounded-md"
                      />
                    </div>
                    {hide ? null : (
                      <div className="news-one__date">
                        <p>{news.date}</p>
                      </div>
                    )}

                    <div className="news-one__content h-[300px] flex flex-col justify-between">
                      <ul className="news-one__meta list-unstyled">
                        <li>
                          <a
                            href={news.link}
                            className="no-underline text-black hover:text-blue-600 font-bold"
                          >
                            {news.tag}
                          </a>
                        </li>
                      </ul>

                      <p className="news-one__title font-extralight normal-case text-lg">
                        <a
                          href={news.link}
                          className="no-underline text-black hover:text-blue-600"
                        >
                          {news.title}
                        </a>
                      </p>

                      <div className="news-one__bottom">
                        <div className="news-one__button">
                          <a
                            href={news.link}
                            className="no-underline text-blue-600 hover:underline"
                          >
                            Read More
                          </a>
                        </div>
                        <div className="news-one__comment">
                          <a
                            href={news.link}
                            className="no-underline text-gray-500 hover:text-blue-600"
                          >
                            <i className="fas fa-comments" /> {news.review}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {/* Pagination Buttons */}
          <div className="mt-8 flex items-center gap-4">
            <button
              onClick={handlePrev}
              disabled={currentPage === 1}
              className={`${
                currentPage === 1
                  ? "bg-gray-500 opacity-50 cursor-not-allowed"
                  : "bg-[#CC8C66] hover:bg-[#a47052]"
              } text-white px-2 py-1 rounded-md`}
            >
              <ChevronLeft />
            </button>
            <button
              onClick={handleNext}
              disabled={currentPage === totalPages}
              className={`${
                currentPage === totalPages
                  ? "bg-gray-500 opacity-50 cursor-not-allowed"
                  : "bg-[#CC8C66] hover:bg-[#a47052]"
              } text-white px-2 py-1 rounded-md`}
            >
              <ChevronRight />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// Default Props and PropTypes
Slider_card.propTypes = {
  projects: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
      bed: PropTypes.number.isRequired,
      location: PropTypes.string.isRequired,
      size: PropTypes.number.isRequired,
    })
  ),
};

Slider_card.defaultProps = {
  projects: [],
};

export default Slider_card;
